//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { BillingProfileDefaultMode } from './Enums';

export class StudentBillingProfileInputItem extends ItemBase {
    BillingRate: number = 0;
    DefaultBillingMode: BillingProfileDefaultMode = BillingProfileDefaultMode.None;
    EventCategoryID: string | null = null;
    LessonDuration: number = 0;
    MakeUpMinutes: number = 0;
    TeacherID: string | null = null;

    constructor(initializer?: Partial<StudentBillingProfileInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "StudentBillingProfileInputItem";
}
